import React from 'react';

import styled from 'styled-components';

import promoColors from '../../../theme/promoColors';
import { PromoDangerouslyHtml } from '../../no-auth/common/PromoDangerouslyHtml/PromoDangerouslyHtml';

const CopyRow = styled.div`
    margin-bottom: 32px;

    a.link:link:hover,
    a.link:visited:hover {
        color: ${promoColors.gray40};
    }

    a.link:focus-visible {
        background-color: ${promoColors.gray20};
        border-radius: 2px;
        outline: 1px dashed ${promoColors.gray40};
    }
`;

export default function Copyright(props) {
    return (
        <CopyRow>
            <PromoDangerouslyHtml dangerouslyHtml={props.copyright} color="gray80" tag="p" />
        </CopyRow>
    );
}
